import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Pay from './pay.jsx';
import SellerVerificationRequired from './sellerVerificationRequired.jsx';
import { createPaylink } from '../../payment/paymentActions.js';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import paymentPropTypes from '../../../paymentPropTypes.js';

const AgreementAcceptedDetails = ({
    agreement,
    payment,
    partner,
    handleClickPay,
}) => {
    if (partner.verificationStatus === 'NOT_VERIFIED') {
        return <SellerVerificationRequired partner={partner} />;
    }

    return (
        <Pay
            agreement={agreement}
            handleClickPay={handleClickPay}
            partner={partner}
            payment={payment}
        />
    );
};

AgreementAcceptedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    handleClickPay: PropTypes.func.isRequired,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        payment: state.payment,
    };
}

const mapDispatchToProps = { handleClickPay: createPaylink };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickPay: () =>
            dispatchProps.handleClickPay({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    AgreementAcceptedDetails
);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/agreementAcceptedDetails.jsx